import { ExecuteEndpoint } from '../../components/common/BaseApiService';
import { GearDocumentMetadata } from '../../Model/GearDocumentMetadata';
import { GetDocumentVersionMetadataRequest } from '../../Model/requests/GetDocumentVersionMetadataRequest';
import { GetDocumentVersionsRequest } from '../../Model/requests/GetDocumentVersionsRequest';
import { DocumentVersionResponse } from '../../Model/responseDtos/DocumentVersionResponse';

export const buildDocumentVersionEndpointPath = (
  contentType: string,
  documentId: string,
  versionId: string,
  indexId: number,
  displayInBrowser = false
) =>
  `content-types/${contentType}/documents/${documentId}/versions/${versionId}/content?indexId=${indexId}&displayInBrowser=${displayInBrowser}`;

export class VersionsService {
  public async getVersions(dto: GetDocumentVersionsRequest): Promise<DocumentVersionResponse[]> {
    const searchParams = new URLSearchParams();
    searchParams.append('indexId', dto.indexId.toString());
    const queryParams = `?${searchParams.toString()}`;

    return ExecuteEndpoint(`content-types/${dto.ctName}/documents/${dto.documentId}/versions${queryParams}`, 'GET');
  }

  public async getVersionMetadata(dto: GetDocumentVersionMetadataRequest): Promise<{ metadata: GearDocumentMetadata }> {
    const searchParams = new URLSearchParams();
    searchParams.append('indexId', dto.indexId.toString());
    const queryParams = `?${searchParams.toString()}`;

    return ExecuteEndpoint(
      `content-types/${dto.ctName}/documents/${dto.documentId}/versions/${dto.versionId}${queryParams}`,
      'GET'
    );
  }
}
